import styled from "styled-components";
import CapTooltipWithInfo from "../CapTooltipWithInfo";
import { CAP_SPACE_08 } from "../styled/variables";

export const StyledCapToolTipWithInfo = styled(CapTooltipWithInfo)`
  &.cap-tooltip-with-info.info-icon {
    margin-right: ${CAP_SPACE_08};
  }
`;